import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import styles from './BottomNavbar.module.css';
import { isDarkModeOn } from '../../util/helper';
import './BottomNavbar.css';

const BottomNavbar = () => {
    const location = useLocation();
    const { t } = useLanguage();

    return (
        <>
            <section className="panel-space"></section>
            <div className="navbar-menu">
                <div className="scanner-bg">
                    <Link to={'#'} className="scanner-btn">
                        {/*<img className="img-fluid" src={"/assets/images/svg/scan.svg"} alt="scan"/>*/}
                        <img
                            className={`img-fluid ${styles.scannerImg}`}
                            src={'/assets/images/logo/coin_white.png'}
                            alt="scan"
                        />
                    </Link>
                </div>
                <ul>
                    <li className={location.pathname === '/' ? 'active' : ''}>
                        <Link to="/">
                            <div className="icon">
                                {isDarkModeOn() ? (
                                    <img
                                        className="unactive"
                                        src={'/assets/images/svg/home-icon-white.svg'}
                                        alt="Xpenso"
                                    />
                                ) : (
                                    <img
                                        className="unactive"
                                        src={'/assets/images/svg/home-icon-u.svg'}
                                        alt="Xpenso"
                                    />
                                )}
                                <img
                                    className="active"
                                    src={'/assets/images/svg/home-icon-f.svg'}
                                    alt="Xpenso"
                                />
                            </div>
                            <h5 className="active">{t('home')}</h5>
                        </Link>
                    </li>

                    <li className={location.pathname === '/statistics' ? 'active' : ''}>
                        <Link to="/statistics">
                            <div className="icon">
                                <img
                                    className="unactive"
                                    src={'/assets/images/svg/statistics-trend.svg'}
                                    alt="Statistics"
                                />
                                <img
                                    className="active"
                                    src={'/assets/images/svg/statistics-trend-fill.svg'}
                                    alt="Statistics"
                                />
                            </div>
                            <h5>{t('statistics')}</h5>
                        </Link>
                    </li>

                    {/* Placeholder for center button */}
                    <li></li>

                    <li className={location.pathname === '/reports' ? 'active' : ''}>
                        <Link to="/reports">
                            <div className="icon">
                                <img
                                    className="unactive"
                                    src={'/assets/images/svg/bar-chart.svg'}
                                    alt="bag"
                                />
                                <img
                                    className="active"
                                    src={'/assets/images/svg/bar-chart-fill.svg'}
                                    alt="bag"
                                />
                            </div>
                            <h5>{t('reports')}</h5>
                        </Link>
                    </li>

                    <li className={location.pathname === '/profile' ? 'active' : ''}>
                        <Link to="/profile">
                            <div className="icon">
                                <img
                                    className="unactive"
                                    src={'/assets/images/svg/user.svg'}
                                    alt="profile"
                                />
                                <img
                                    className="active"
                                    src={'/assets/images/svg/user-fill.svg'}
                                    alt="profile"
                                />
                            </div>
                            <h5>{t('profile')}</h5>
                        </Link>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default BottomNavbar;
